import styled from 'styled-components';

import Dialog from "../../../../blocks/dialog";

export const EditDialog = styled(Dialog)`
  padding-left: 0;
`